module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-13.svg?bb48f9f460f368424e5c8b6ab4b3b1b0";